"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTRS_QD_ARR = exports.OTRS_QID = void 0;
exports.OTRS_QID = {
    ADOBECAPTIVATE: 12,
    ADOBECONNECT: 5,
    ADOBECAPTIVATEPRIME: 6,
    TRAIN: 11,
    KICK: 14,
    SPFTEST: 20
};
exports.OTRS_QD_ARR = [
    exports.OTRS_QID.ADOBECAPTIVATE,
    exports.OTRS_QID.ADOBECONNECT,
    exports.OTRS_QID.ADOBECAPTIVATEPRIME,
    exports.OTRS_QID.KICK,
    exports.OTRS_QID.TRAIN,
    exports.OTRS_QID.SPFTEST
];
